import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { Icon, type IconName } from './Icon';
import s from './Chip.module.css';

/** A static outline tag (12px). `soft` = filled on surface-3. */
export function Tag({ children, soft, className }: { children: ReactNode; soft?: boolean; className?: string }) {
  return <span className={cx(soft ? s.soft : s.tag, className)}>{children}</span>;
}

type ChipProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> & {
  /** light = white when selected (industry); accent = orange tint (categories, layouts); dropdown = toolbar. */
  variant?: 'light' | 'accent' | 'dropdown';
  selected?: boolean;
  icon?: IconName;
  iconSize?: number;
  children: ReactNode;
};

/** A selectable or dropdown chip (pill). */
export function Chip({ variant = 'accent', selected, icon, iconSize = 12, className, children, type = 'button', ...rest }: ChipProps) {
  return (
    <button
      type={type}
      aria-pressed={variant === 'dropdown' ? undefined : !!selected}
      className={cx(s.chip, s[variant], className)}
      {...rest}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      {children}
      {variant === 'dropdown' && <Icon name="chevron-down" size={14} />}
    </button>
  );
}
